import { Input, InputProps } from 'antd';
// import { useIntl } from 'react-intl';
import './style.scss';
import SvgEyeInvisibleOutlined from '../svg/SvgEyeInvisibleOutlined';
import SvgEyeOutlined from '../svg/SvgEyeOutlined';
import { TextAreaProps } from 'antd/es/input';

interface CustomInputProps {
  placeholder?: string;
  className?: string;
  type?: 'text' | 'password' | 'textarea';
  width?: number;
  height?: number;
  props?: InputProps | TextAreaProps;
  prefix?: React.ReactNode;
  value?: any;
  onChange?: (e: any) => void;
  onBlur?: (e: any) => void;
}

const CustomInputAuthen = ({
  placeholder,
  className,
  type = 'text',
  width,
  height,
  prefix,
  props,
  value,
  onChange,
  onBlur,
}: CustomInputProps) => {
  const inputStyle = { height, width };

  switch (type) {
    case 'text':
      return (
        <Input
          style={inputStyle}
          maxLength={255}
          placeholder={placeholder || undefined}
          className={`ant-custom-input-authen ${className}`}
          prefix={prefix}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          {...(props as InputProps)}
        />
      );
    case 'password':
      return (
        <Input.Password
          style={inputStyle}
          maxLength={255}
          placeholder={placeholder || undefined}
          className={`ant-custom-input-authen ${className}`}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          {...(props as InputProps)}
          autoComplete="new-password"
          prefix={prefix}
          iconRender={(visible) =>
            visible ? (
              <span>
                <SvgEyeInvisibleOutlined />
              </span>
            ) : (
              <span>
                <SvgEyeOutlined />
              </span>
            )
          }
        />
      );
    case 'textarea':
      return (
        <Input.TextArea
          style={inputStyle}
          maxLength={255}
          placeholder={placeholder || undefined}
          className={`ant-custom-input-authen ${className}`}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          {...(props as TextAreaProps)}
        />
      );
    default:
      return null;
  }
};
export default CustomInputAuthen;
